import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-sm', className)}
      {...props}
    />
  )
}
